module.exports = "\n#tempofit-wrapper {\n    min-height: 100%;\n    position: relative;\n}\n\n#tempofit-content {\n    padding-bottom: 130px;\n}\n\n"